import { useEffect, useState } from "react";
import { Box, Button, Link, Typography } from "@mui/material";

const STORAGE_KEY = "cosmetixhub_cookie_consent";

const CookieConsentBanner = () => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined") return;
    const saved = window.localStorage.getItem(STORAGE_KEY);
    if (!saved) {
      setOpen(true);
    }
  }, []);

  const acceptCookies = () => {
    if (typeof window !== "undefined") {
      window.localStorage.setItem(STORAGE_KEY, "accepted");
    }
    setOpen(false);
  };

  if (!open) return null;

  return (
    <Box
      component="aside"
      sx={{
        position: "fixed",
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 1400,
        backgroundColor: "rgba(16, 24, 40, 0.96)",
        color: "#fff",
        px: { xs: 2, sm: 3 },
        py: 2,
        boxShadow: "0 -4px 20px rgba(0,0,0,0.15)",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", sm: "row" },
          alignItems: "center",
          justifyContent: "space-between",
          gap: 2,
          maxWidth: 1200,
          mx: "auto",
        }}
      >
        <Box sx={{ flex: 1, minWidth: 0 }}>
          <Typography sx={{ fontSize: 14, color: "rgba(255,255,255,0.92)", mb: 1 }}>
            We use cookies and local storage to improve usability and navigation. No tracking cookies are set without your consent.
          </Typography>
          <Typography sx={{ fontSize: 13, color: "rgba(255,255,255,0.72)" }}>
            By continuing to use the site, you agree to our{' '}
            <Link href="/privacy-policy" underline="always" sx={{ color: "#ff80bf" }}>
              Privacy Policy
            </Link>
            .
          </Typography>
        </Box>

        <Button
          variant="contained"
          size="small"
          onClick={acceptCookies}
          sx={{
            textTransform: "none",
            backgroundColor: "#ff5c9f",
            color: "#fff",
            '&:hover': { backgroundColor: '#f85088' },
          }}
        >
          Accept Cookies
        </Button>
      </Box>
    </Box>
  );
};

export default CookieConsentBanner;
